module.exports = __webpack_public_path__ + "media/images/3_0-93984e798d083dde1ea3edd98abb63ff.png";